import React from 'react';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircleSharp';
import CancelIcon from '@mui/icons-material/CancelSharp';
import variables from 'src/style/variable/variables.module.scss';
import { useTranslation } from 'src/i18n';

export default function CommissioningStatusIcon ({ status }) {
  const { t } = useTranslation();
  const containerStyle = { display: 'flex', alignItems: 'center' };

  if (status === 'pass') {
    return <div style={containerStyle}>
      <CheckCircleIcon style={{ color: variables.success, fontSize: 24, marginRight: 8 }} />
      <span>{t('common.pass')}</span>
    </div>;
  }
  if (status === 'pass-with-notes') {
    return <div style={containerStyle}>
      <CheckCircleIcon style={{ color: variables.warning, fontSize: 24, marginRight: 8 }} />
      <span>{t('common.passWithNotes')}</span>
    </div>;
  }
  if (status === 'failed') {
    return <div style={containerStyle}>
      <CancelIcon style={{ color: variables.error, fontSize: 24, marginRight: 8 }} />
      <span>{t('common.failed')}</span>
    </div>;
  }
  return <span>—</span>;
}

CommissioningStatusIcon.propTypes = {
  status: PropTypes.string,
};

CommissioningStatusIcon.defaultProps = {
  status: null,
};
